
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { formatDateTime } from '../utils/utils'
export default {
name: 'Attendance-count',
data () {
return {
value9: true,
thisWeek: '',
thisWeekLabel: '',
dateType: '',
pluginMax: '',
attendanceRecordList: [],
eventOffDuty: {},  // 下班时间
eventOnDuty: {},   // 上班时间
nodata: false
}
},
filters: {

source: function (value) {
let result = ''
if (value == '0') {
result = '电脑打卡'
} else if (value == '1') {
result = '网络摄像头打卡'
} else if (value == '2') {
result = '手机APP打卡'
} else if (value == '3') {
result = '微信打卡'
} else if (value == '100') {
result = '考勤机(密码)打卡'
} else if (value == '101') {
result = '考勤机(指纹)打卡'
} else if (value == '102') {
result = '考勤机(刷卡)打卡'
} else if (value == '115') {
result = '考勤机(人脸)打卡'
} else if (value == '9001') {
result = '系统检测'
}
return result
},
time: function (value) {
let time = formatDateTime(value)
return time
},
signType: function (value) {

let result = ''
if (value == '8001') {
result = '上午上班正常打卡'
} else if (value == '8002') {
result = '上午上班迟到打卡'
} else if (value == '8003') {
result = '下午上班正常打卡'
} else if (value == '8004') {
result = '下午上班迟到打卡'
} else if (value == '8005') {
result = '下午下班正常打卡'
} else if (value == '8041') {
result = '上午早退'
} else if (value == '8042') {
result = '下午早退'
} else if (value == '8051') {
result = '上午旷工'
} else if (value == '8052') {
result = '下午旷工'
} else if (value == '8061') {
result = '工作日加班'
} else if (value == '8062') {
result = '周末加班'
} else if (value == '8063') {
result = '法定日加班'
} else if (value == '8091') {
result = '未签到'
} else if (value == '8092') {
result = '未签退'
}
return result
},
dateTypeFormatter: function (value) {
console.log(value)

let result = ''
if (value == '1') {
result = '正常工作日'
} else if (value == '2') {
result = '正常周末'
} else if (value == '3') {
result = '法定假期'
} else if (value == '4') {
result = '法定上班'
}
return result
}
},
components: {
Flexbox,
FlexboxItem,
Divider,
Timeline,
TimelineItem,
Datetime, XHeader, CellBox, Group,
},
mounted () {
let time = (new Date()).valueOf()
this.pluginMax = this.thisWeek = formatDateTime(time).split(' ')[0]
this.changeDate()
this.getUserAttendanceRecordList()
},
methods: {
showPlugin () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.thisWeek,
endDate: this.pluginMax,
onConfirm (val) {
console.log('plugin confirm', val)
that.thisWeek = val
that.changeDate()
that.getUserAttendanceRecordList()
},
onShow () {
console.log('plugin show')
},
onHide () {
console.log('plugin hide')
}
})
},
changeDate () {
let getDate = new Date(this.thisWeek)
let dateArray = new Array('星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六')
let week = getDate.getDay()
this.thisWeekLabel = dateArray[week]
},


getUserAttendanceRecordList () {
this.$vux.loading.show({
text: '加载中'
})
this.axios({
url: this.$store.state.url + '/wechat/login/user',
method: 'get',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
}
}).then((response) => {
console.log(response.data.account.id)
this.axios({
url: this.$store.state.url + '/app/getUserAttendanceRecordList?userId=' + response.data.account.id + '&year=' + this.thisWeek.split('-')[0] + '&month=' + this.thisWeek.split('-')[1] + '&day=' + this.thisWeek.split('-')[2],
method: 'get',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
}
}).then((response) => {
this.attendanceRecordList = response.data.attendanceRecordList
this.dateType = response.data.dateType.type
if (this.attendanceRecordList.length > 0) {
this.nodata = false
} else {
this.nodata = true
}
this.$vux.loading.hide()
}).catch((response) => {
this.$vux.loading.hide()
})
}).catch((response) => {
console.log(response)
})
}
}
}



// WEBPACK FOOTER //
// ./src/page/Attendance-count.vue